import { Federation } from "@/models/Federation";

const getOrg = (
  id: number,
  associations: Array<Federation>
): Federation | undefined => associations.find((org) => org.nhoNumber === id);

const getAllParentNhoNumbers = (
  id: number,
  associations: Array<Federation>
): Array<number> => {
  const nhoNumbers = [];
  let currentOrg = getOrg(id, associations);

  while (currentOrg) {
    nhoNumbers.push(currentOrg.nhoNumber);

    if (currentOrg.federationParentNumber) {
      currentOrg = getOrg(currentOrg.federationParentNumber, associations);
    } else {
      break;
    }
  }

  return nhoNumbers;
};

export default getAllParentNhoNumbers;
